let CLIENT_ID;
let ISSUER;
let LOGROCKET_APP_ID;
let CAPACITY_PLANNING_URL;
let JIRA_TICKETING_SYSTEM;

if (import.meta.env.VITE_MODE === 'dev') {
  CLIENT_ID = import.meta.env.VITE_CLIENT_ID;
  ISSUER = import.meta.env.VITE_ISSUER;
  LOGROCKET_APP_ID = import.meta.env.VITE_LOGROCKET_APP_ID;
  CAPACITY_PLANNING_URL = import.meta.env.VITE_CAPACITY_PLANNING_URL;
  JIRA_TICKETING_SYSTEM = import.meta.env.VITE_JIRA_TICKETING_SYSTEM;
} else {
  CLIENT_ID = window.config.clientId;
  ISSUER = window.config.issuer;
  LOGROCKET_APP_ID = window.config.logRocketAppId;
  CAPACITY_PLANNING_URL = window.config.capacityPlanningUrl;
  JIRA_TICKETING_SYSTEM = window.config.jiraTicketingSystem;
}

const REDIRECT_URI = `${window.location.origin}/login/callback`;
const OKTA_TESTING_DISABLEHTTPSCHECK = false;

export default {
  oidc: {
    clientId: CLIENT_ID || '',
    issuer: ISSUER || '',
    redirectUri: REDIRECT_URI || '',
    scopes: ['openid', 'profile', 'email', 'groups'],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK
  },
  logRocket: {
    appId: LOGROCKET_APP_ID || ''
  },
  capacityPlanningUrl: CAPACITY_PLANNING_URL || '',
  // Feature flag: only show the "Report an Issue" ticketing widget when
  // explicitly enabled. Accepts the string 'true' (env) or boolean true (window.config).
  jiraTicketingSystem: String(JIRA_TICKETING_SYSTEM).toLowerCase() === 'true'
};
